import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {},
    template
})

export default class {
    constructor ($translate, toastr, CompanyResource) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.CompanyResource = CompanyResource;

        this.loading = true;
        this.ssoEnabled = false;
        this.ssoActive = false;

        // IdP fields (customer fills in)
        this.idpEntityId = '';
        this.ssoUrl = '';
        this.idpX509Cert = '';
        this.metadataUrl = '';

        // SP details (read-only, customer copies to their Entra)
        const apiUrl = SEED_CORE.ENV.API_URL;
        this.spEntityId = `${apiUrl}user/auth/saml-login-response`;
        this.acsUrl = `${apiUrl}user/auth/saml-login-response`;
    }

    $onInit () {
        return this.CompanyResource.ssoSetting().$promise
            .then((response) => {
                if (response.id) {
                    this.ssoEnabled = Boolean(response.isEnabled);
                    this.ssoActive = Boolean(response.isEnabled);
                    this.idpEntityId = response.idpEntityId || '';
                    this.ssoUrl = response.idpSsoUrl || '';
                    this.idpX509Cert = response.idpX509Cert || '';
                    this.metadataUrl = response.metadataUrl || '';
                }
            })
            .catch(() => {})
            .finally(() => {
                this.loading = false;
            });
    }

    // Entra always issues the entity id with a trailing slash; normalize so a
    // missing/extra slash typed by the admin can't break issuer validation.
    normalizeEntityId (value) {
        return value ? `${value.trim().replace(/\/+$/, '')}/` : value;
    }

    toggleSso () {
        this.idpEntityId = this.normalizeEntityId(this.idpEntityId);
        if (this.ssoEnabled && (!this.idpEntityId || !this.ssoUrl)) {
            return;
        }
        this.CompanyResource.saveSsoSetting({
            isEnabled: this.ssoEnabled,
            idpEntityId: this.idpEntityId,
            idpSsoUrl: this.ssoUrl,
            idpX509Cert: this.idpX509Cert,
            metadataUrl: this.metadataUrl
        }).$promise
            .then(() => {
                this.ssoActive = this.ssoEnabled;
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            })
            .catch((error) => {
                this.ssoEnabled = !this.ssoEnabled;
                if (error.data) {
                    error.data.forEach((err) => this.toastr.error(err.message));
                }
            });
    }

    save () {
        this.idpEntityId = this.normalizeEntityId(this.idpEntityId);
        this.saving = true;
        return this.CompanyResource.saveSsoSetting({
            isEnabled: this.ssoEnabled,
            idpEntityId: this.idpEntityId,
            idpSsoUrl: this.ssoUrl,
            idpX509Cert: this.idpX509Cert,
            metadataUrl: this.metadataUrl
        }).$promise
            .then(() => {
                this.ssoActive = this.ssoEnabled;
                this.showCertInput = false;
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            })
            .catch((error) => {
                if (error.data) {
                    error.data.forEach((err) => this.toastr.error(err.message));
                }
            })
            .finally(() => {
                this.saving = false;
            });
    }

    parseMetadata () {
        this.idpEntityId = this.normalizeEntityId(this.idpEntityId);
        this.parsing = true;
        return this.CompanyResource.saveSsoSetting({
            isEnabled: this.ssoEnabled,
            idpEntityId: this.idpEntityId,
            idpSsoUrl: this.ssoUrl,
            idpX509Cert: this.idpX509Cert,
            metadataUrl: this.metadataUrl,
            parseMetadata: true
        }).$promise
            .then((response) => {
                this.idpX509Cert = response.idpX509Cert || '';
                this.showCertInput = false;
                this.toastr.success(this.$translate.instant('integration.Certificate parsed successfully'));
            })
            .catch((error) => {
                if (error.data) {
                    error.data.forEach((err) => this.toastr.error(err.message));
                }
            })
            .finally(() => {
                this.parsing = false;
            });
    }

    copyUrl (url) {
        navigator.clipboard.writeText(url)
            .then(() => this.toastr.success(this.$translate.instant('integration.URL copied')));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/integration/sso/index.js